import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Field } from 'redux-form'
import styles from './_charField.css'
import classnames from 'classnames'
import fieldProps from '../fieldProps'
import FieldLabel from '../FieldLabel'
import FieldError from '../FieldError'

export class CharField extends Component {

  static defaultProps = {
    onChange: () => {},
  }

  handleChange = (evt) => {
    this.props.input.onChange(evt)
    this.props.onChange(evt)
  }

  render () {
    const {
      bold,
      input,
      required,
      name,
      labelComponent,
      errorComponent,
      type,
      slim,
      placeholder,
      disabled,
      afterComponent,
      inputContainerClassName,
      short,
      min,
      max,
      step,
      maxLength,
      meta: {
        touched,
        error,
      },
    } = this.props

    const showError = Boolean(touched && error)
    const className = classnames(styles.container, this.props.className, {
      [styles.disabled]: disabled,
      [styles.slim]: slim,
    })

    return (
      <label htmlFor={name} className={className}>
        <FieldLabel
          bold={bold}
          labelComponent={labelComponent}
          required={required}
          disabled={disabled}
        />

        <div className={classnames(styles.inputContainer, inputContainerClassName, {
          [styles.afterInputContainer]: !!afterComponent,
          [styles.short]: !!short,
        })}>
          <input
            {...input}
            onChange={this.handleChange}
            min={min}
            max={max}
            step={step}
            id={name}
            type={type}
            disabled={disabled}
            maxLength={maxLength}
            placeholder={placeholder}
            size={20}
            className={classnames(styles.input, { [styles.error]: showError })}
          />
          {afterComponent}
        </div>

        <FieldError
          errorComponent={errorComponent}
          showError={showError}
          errorMessage={error}
        />
      </label>
    )
  }

}

CharField.propTypes = fieldProps

export const renderField = (field) => <CharField {...field} />
export const FieldWrapper = (props) => <Field {...props} component={renderField} />

FieldWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.node,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
}

export default FieldWrapper



// WEBPACK FOOTER //
// ./src/components/forms/CharField/CharField.jsx